import { useState, useCallback } from 'react';
import { _js } from '@ifixit/utils/localize';
import DiagramTooltip from './diagramTooltip';
import copyToClipboard from 'Shared/copy_to_clipboard';
import { FaIcon } from '@ifixit/ui/components/icon';
import { motion, AnimatePresence } from 'framer-motion';

function ClipboardIcon() {
   return (
      <AnimatePresence>
         <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <FaIcon
               name="clipboard"
               style="regular"
               className="text-sm text-gray-800 align-middle"
            />
         </motion.div>
      </AnimatePresence>
   );
}

function CheckIcon() {
   return (
      <AnimatePresence>
         <motion.div initial={{ opacity: 1 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}>
            <FaIcon
               name="clipboard-check"
               style="regular"
               className="text-sm text-gray-800 align-middle"
            />
         </motion.div>
      </AnimatePresence>
   );
}

const CopyIcon = ({ copyText }: { copyText: string }) => {
   const [isOpen, setIsOpen] = useState(false);

   const onOpen = useCallback(() => setIsOpen(true), []);
   const onClose = useCallback(() => setIsOpen(false), []);

   const copy = () => {
      copyToClipboard(copyText);
      onOpen();
      setTimeout(() => {
         onClose();
      }, 2000);
   };

   return (
      <DiagramTooltip
         content={_js('Copied!')}
         isOpen={isOpen}
         onOpen={onOpen}
         onClose={onClose}
         closeOnBlur={false}
         closeOnEsc={false}
         autoFocus={false}
         returnFocusOnClose={false}
      >
         <button
            onClick={copy}
            aria-label="Copy Text"
            className="inline-flex items-center justify-center p-2 rounded-md hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-300"
         >
            {isOpen ? <CheckIcon /> : <ClipboardIcon />}
         </button>
      </DiagramTooltip>
   );
};

export default CopyIcon;
